import React from 'react';
import { Container, Draggable } from 'react-smooth-dnd';
import { connect } from 'react-redux';
import asyncDispatch from '../../../../../services/mini/asyncDispatch';
import * as actions from '../../../../../redux/testMode/actions.testMode';
import _ from 'lodash';
import Dialog from '../Dialog/Dialog';
import DialogsStatusPanel from '../DialogsStatusPanel/DialogsStatusPanel';
import CommandsPanel from '../../CommandsPanel/CommandsPanel';
import { Loader } from '../../../../components/Loader/Loader';
import NoExistingConversationView from '../../NoExistingConversationView/NoExistingConversationView';
import isLocalStorageAvailable from '../../../../../services/mini/isLocalStorageAvailable';
import { getCssForTextChatLinks } from '../../../../../../../alan_btn/src/styles/chat';
const $ = require('jquery');

class TestModePanel extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
        };

        this.testPanelScrollablePart = React.createRef();
    }

    componentDidMount() {
        this.getDialogsContent().then(() => {
            this.applyRememberedScrollPosition();
        });
    }

    componentDidUpdate(prevProps) {
        const { conversation } = this.props;

        if (conversation?.id !== prevProps.conversation?.id) {
            this.getDialogsContent().then(() => {
                this.applyRememberedScrollPosition();
            });
        }
    }

    applyRememberedScrollPosition = () => {
        const { project, conversation } = this.props;
        if (isLocalStorageAvailable()) {
            let pos;
            try {
                pos = JSON.parse(localStorage.getItem(`test-case-scroll-pos-${conversation.id}-${project.projectId}`));
                const scrollPart = this.testPanelScrollablePart.current;
                if (pos) {
                    scrollPart.scrollTop = pos.y;
                    scrollPart.scrollLeft = pos.x;
                }
            } catch (err) {

            }
        }
    }

    rememberScrollPosition = (_.debounce(() => {
        const { project, conversation } = this.props;
        if (isLocalStorageAvailable()) {
            const scrollPart = this.testPanelScrollablePart.current;
            localStorage.setItem(`test-case-scroll-pos-${conversation.id}-${project.projectId}`,
                JSON.stringify({
                    x: $(scrollPart).prop('scrollLeft'),
                    y: $(scrollPart).prop('scrollTop'),
                }));
        }
    }, 250))

    getDialogsContent() {
        const {
            conversation,
            getDialogsContent
        } = this.props;

        return new Promise((resolve, reject) => {
            if (conversation?.id) {
                getDialogsContent({
                    conversationId: conversation.id
                }).then(() => {
                    resolve();
                });
            }
        });
    }

    scrollToLastDialog = () => {
        setTimeout(() => {
            const scrollPart = this.testPanelScrollablePart.current;
            $(scrollPart).animate({
                scrollTop: 0,
                scrollLeft: $(scrollPart).prop('scrollWidth'),
            }, 600);
        }, 300);
    }

    scrollToLastBubble = (textArea) => {
        setTimeout(() => {
            const box = textArea.getBoundingClientRect();
            const scrollPart = this.testPanelScrollablePart.current;
            const height = $(scrollPart).prop('clientHeight');
            const inViewport = box.top < height && box.bottom >= 0;
            if (!inViewport) {
                textArea.scrollIntoView({ behavior: 'smooth' });
            }
        }, 300);
    }

    addDialog = () => {
        const {
            dialogTree,
            conversation,
            addDialog
        } = this.props;
        addDialog({
            conversationId: conversation.id,
            dialogTree
        });

        this.scrollToLastDialog();
    }

    pasteDialog = () => {
        const {
            dialogTree,
            conversation,
            pasteDialog,
            copiedNodes
        } = this.props;
        pasteDialog({
            conversationId: conversation.id,
            dialogTree,
            phrases: copiedNodes
        });

        this.scrollToLastDialog();
    }

    onDrop = ({ addedIndex, removedIndex }) => {
        const {
            dialogTree,
            changeDialogOrder,
            conversation
        } = this.props;

        changeDialogOrder({
            conversationId: conversation.id,
            dialogTree,
            addedIndex,
            removedIndex
        });
    }

    render() {
        const {
            dialogTree,
            dialogs,
            environment,
            conversation,
            conversations,
            copiedNodes,
            project,
            isDialogsRefreshingInProcess,
            isOneDialogRefreshingInProcess,
            refreshingIsInProcess
        } = this.props;

        const dialogsKeys = dialogs ? Object.keys(dialogs) : [];

        const isConversationEmpty = dialogTree?.hasEmptyChildren() === true;
        const isAddNewDialogDisabled = isConversationEmpty ||
            isDialogsRefreshingInProcess ||
            isOneDialogRefreshingInProcess ||
            refreshingIsInProcess;

        return (
            <div className={`test-mode-panel ${environment}`}>
                <DialogsStatusPanel />
                <CommandsPanel place="tree" />

                {(
                    conversations === null ||
                    (conversations?.length > 0 && dialogsKeys?.length === 0)
                ) &&
                    <Loader
                        theme="dark"
                        size="big"
                        center={true}
                        appearWithFade={true} />}

                {conversations?.length === 0 &&
                    <NoExistingConversationView
                        environment={environment}
                        conversationName={conversation.name} />}

                {conversations?.length > 0 && dialogsKeys?.length > 0 &&
                    <React.Fragment>
                        <div
                            className="test-mode-panel__body"
                            onScroll={this.rememberScrollPosition}
                            ref={this.testPanelScrollablePart}>
                            <style>
                                {`${getCssForTextChatLinks('', {})}`}
                            </style>
                            <Container
                                dragClass="dialog__dragging"
                                dragHandleSelector=".dialog__dragger"
                                orientation="horizontal"
                                onDrop={this.onDrop}>
                                {dialogsKeys?.map((key, index) => {
                                    const dialog = dialogs[key];
                                    return <Draggable key={key}>
                                        <Dialog
                                            dialogTree={dialogTree}
                                            dialog={dialog}
                                            scrollToLastBubble={this.scrollToLastBubble}
                                            index={index}
                                            project={project}
                                            environment={environment}
                                        />
                                    </Draggable>;
                                })}
                            </Container>
                            <div className="test-mode-panel__actions-panel">
                                <div className={`test-mode-panel__actions-panel-btn ${isAddNewDialogDisabled && 'disabled'}`} onClick={this.addDialog} title="Add new dialog">
                                    <i className="icon icon-alan-add-circle" />
                                </div>
                                {copiedNodes && <div className="test-mode-panel__actions-panel-btn" onClick={this.pasteDialog} title="Paste copied dialog">
                                    <i className="icon icon-alan-duplicate" />
                                </div>}
                            </div>
                            <div className="test-mode-panel__add-dialog-btn-separator" />
                        </div>
                    </React.Fragment>}
            </div>
        );
    }
}


function mapStateToProps({ testMode, projectsInfo }) {
    return {
        dialogs: testMode.dialogs,
        dialogTree: testMode.dialogTree,
        expectedResponsesAreShownGlobally: testMode.expectedResponsesAreShownGlobally,
        copiedNodes: testMode.copiedNodes,
        codeLinksAreShownGlobally: testMode.codeLinksAreShownGlobally,
        conversations: projectsInfo.currentProject.conversations,
        isModelActual: projectsInfo.currentProject.isModelActual,
        isDialogsRefreshingInProcess: testMode.isDialogsRefreshingInProcess,
        isOneDialogRefreshingInProcess: testMode.isOneDialogRefreshingInProcess,
        refreshingIsInProcess: testMode.refreshingIsInProcess,

    };
}

function mapDispatchToProps(dispatch) {
    return {
        getDialogsContent: (param) => asyncDispatch(actions.getDialogsContent, dispatch, param),
        addDialog: (param) => dispatch(actions.addDialog(param)),
        pasteDialog: (param) => asyncDispatch(actions.pasteDialog, dispatch, param),
        showExpectedResponses: () => dispatch(actions.showExpectedResponses()),
        hideExpectedResponses: () => dispatch(actions.hideExpectedResponses()),
        showCodeLinks: () => dispatch(actions.showCodeLinks()),
        hideCodeLinks: () => dispatch(actions.hideCodeLinks()),
        changeDialogOrder: (param) => asyncDispatch(actions.changeDialogOrder, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(TestModePanel);
